import { deleteSuggestion as deleteSuggestionAction } from '../../../../actions/suggestions/suggestions'
import { handleResponse } from './handle-response'
import { handleError } from './handle-error'

/**
 * Öneriyi siler
 * @param {Number|String} id - Silinecek öneri ID'si
 * @param {Object} params - Ek parametreler (assetId vb.)
 * @returns {Promise<Object>} Silme işlemi sonucu
 */
export const deleteSuggestion = async (id, params = {}) => {
  try {
    // API çağrısını assetId ile yap
    const response = await deleteSuggestionAction(id, params)

    // Yanıtı işle
    return handleResponse(response)
  } catch (error) {
    return handleError(error, id)
  }
}

export {
  handleResponse,
  handleError,
}